module.exports = __webpack_public_path__ + "img/hand-index-thumb.b1a8a6f0.svg";